import { TableCell, TableRow, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { brandonGrotesqueBold } from '../../styles/theme';

export const TypographyCalibri24Bold = styled(Typography)({
  fontFamily: 'CalibriBold',
  fontSize: '1.5rem',
  fontWeight: 700,
  color: '#fff'
});

export const TypographyCalibri12Bold = styled(Typography)({
  fontFamily: 'CalibriBold',
  fontSize: '0.75rem',
  fontWeight: 700,
  color: '#002A3A'
});

export const TypographyCalibri12Normal = styled(Typography)({
  fontFamily: 'Calibri',
  fontSize: '0.75rem',
  fontWeight: 400,
  color: '#002A3A'
});

export const TypographyCalibri16Italic = styled(Typography)({
  fontFamily: 'CalibriItalic',
  fontSize: '1rem',
  fontWeight: 400,
  color: '#fff'
});

export const TypographyBg18Bold = styled(Typography)({
  color: '#fff',
  fontSize: '1.125rem',
  fontWeight: 450,
  fontFamily: brandonGrotesqueBold,
  lineHeight: '1.5rem'
});

export const TypographyBg20BlueBold = styled(Typography)({
  color: '#007ACC',
  fontSize: '1.25rem',
  fontWeight: 450,
  fontFamily: brandonGrotesqueBold,
  lineHeight: '1.5rem'
});

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  border: '0.0625rem solid #8BB5C6',
  display: 'table-cell',
  verticalAlign: 'middle'
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.background.default
  }
}));
